import { logistica_GUIA } from "@pcgerente-node/pcg-comun/dist/DTOs";
import { PayloadAction } from "@reduxjs/toolkit";
import axios, { AxiosResponse } from "axios";
import {IApiResponse} from "@pcgerente-node/pcg-comun";
import { baseURL, establecerEstado, handleResponse, headers, reestablecerEstado, seteaError, structureInfoState } from "../helpersRedux";
import { setGuiasRecientesHome } from '../slices/homeSlice';

//logistica_GUIA
export const getGuiasRecientes = (idUsuario: number ) => 
async (dispatch:(action: PayloadAction<structureInfoState<logistica_GUIA[]>>) => void) => {
  try{
    dispatch(setGuiasRecientesHome(reestablecerEstado()))
    let response = await axios.get(`${baseURL}logistica_GUIA/POR_USUARIO/${idUsuario}?recientes=true`, headers)
    .then((res: AxiosResponse<IApiResponse<logistica_GUIA[]>>) => handleResponse(res))
    dispatch(setGuiasRecientesHome(establecerEstado(response)))
  }
  catch(error){
    if(error instanceof Error){
      dispatch(setGuiasRecientesHome(seteaError(error)))
    }
  }
}

